import { gql, TypedDocumentNode } from "@apollo/client";

type CheckTemplatesData = {
  searchTemplates: {
    edges: Array<{
      node: {
        id: string;
      };
    }>;
  };
};

export const CHECK_TEMPLATES: TypedDocumentNode<CheckTemplatesData> = gql`
  query CheckTemplates {
    searchTemplates(input: { first: 1 }) {
      edges {
        node {
          id
        }
      }
    }
  }
`;
